import { render, staticRenderFns } from "./MfrEditor.vue?vue&type=template&id=5fcbe539&"
import script from "./MfrEditor.vue?vue&type=script&lang=ts&"
export * from "./MfrEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports